import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const AAA_PROMO_CODE = "2022AAAP2" 

export const AAAPromoGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(AAA_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({disabled, handleClick}) => {
    return (
      <> 
        <Button
        type="button"
        className="btn"
        primary
        disabled={disabled}
        onClick={() => {
          setSubmissionPromoCode(promoCode)
          handleClick()
        }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
        AAA_PROMO_CODE
    )
  ];

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>
                Enter your T-Mobile or Sprint phone number to begin the redemption process. You will then be prompted to log in to your account
            </p>           
            <img style={{marginTop: "1rem"}} src={"images/AAA/aaa_logo.png"} alt="AAAPromo Logo" className="mb-3"/>
            <p>
                Get One Year of a AAA Basic/Classic Membership On Us!
            </p>            
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{marginBottom: "6px"}}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto"/>
        </div>
        <div className="mx-auto col-md-4">   
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/benefits/aaa-membership-deal" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
